import { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../../api/authApi';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const tokenFromUrl = searchParams.get('token') ?? '';
  const [token, setToken] = useState(tokenFromUrl);
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await resetPassword(token.trim(), newPassword);
      setSuccess(true);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 400) {
        setError('Код недействителен или истёк срок действия.');
      } else {
        setError('Не удалось сбросить пароль. Попробуйте позже.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ewl-auth-page">
      <Container>
        <div className="ewl-auth-card">
          {/* Логотип */}
          <div className="text-center mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{
                width: '3.5rem',
                height: '3.5rem',
                borderRadius: '1rem',
                background: 'linear-gradient(135deg, #4f6ef7 0%, #7c3aed 100%)',
                fontSize: '1.5rem',
                boxShadow: '0 4px 16px rgba(79,110,247,0.35)',
              }}
            >
              📖
            </div>
            <h4 className="fw-bold mb-1" style={{ letterSpacing: '-0.01em' }}>
              English We Love
            </h4>
            <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>
              Новый пароль
            </p>
          </div>

          <Card
            className="border-0"
            style={{ borderRadius: '1rem', boxShadow: '0 4px 24px rgba(0,0,0,0.09)' }}
          >
            <Card.Body className="p-4">
              {error && (
                <Alert
                  variant="danger"
                  className="py-2 px-3 mb-3"
                  style={{ fontSize: '0.875rem', borderRadius: '0.5rem' }}
                >
                  {error}
                </Alert>
              )}

              {success ? (
                <Alert
                  variant="success"
                  className="py-3 px-3 mb-0"
                  style={{ fontSize: '0.875rem', borderRadius: '0.5rem' }}
                >
                  Пароль изменён. Войдите с новым паролем.
                </Alert>
              ) : (
                <Form onSubmit={handleSubmit}>
                  {!tokenFromUrl && (
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-medium" style={{ fontSize: '0.875rem' }}>
                        Код из письма
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={token}
                        onChange={(e) => setToken(e.target.value)}
                        placeholder="Вставьте код из письма"
                        size="lg"
                        required
                        autoComplete="off"
                        style={{ borderRadius: '0.5rem', fontFamily: 'monospace', letterSpacing: '0.05em' }}
                      />
                    </Form.Group>
                  )}

                  <Form.Group className="mb-4">
                    <Form.Label className="fw-medium" style={{ fontSize: '0.875rem' }}>
                      Новый пароль
                    </Form.Label>
                    <Form.Control
                      type="password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      placeholder="••••••••"
                      size="lg"
                      required
                      minLength={8}
                      style={{ borderRadius: '0.5rem' }}
                    />
                  </Form.Group>

                  <Button
                    type="submit"
                    size="lg"
                    className="w-100"
                    disabled={loading}
                    style={{
                      background: 'linear-gradient(135deg, #4f6ef7 0%, #7c3aed 100%)',
                      border: 'none',
                      borderRadius: '0.6rem',
                      fontWeight: 600,
                      letterSpacing: '0.01em',
                    }}
                  >
                    {loading ? 'Сохраняем...' : 'Установить пароль'}
                  </Button>
                </Form>
              )}
            </Card.Body>
          </Card>

          <p className="text-center mt-3 text-muted" style={{ fontSize: '0.875rem' }}>
            {success ? (
              <Link
                to="/login"
                style={{ color: 'var(--bs-primary)', fontWeight: 500, textDecoration: 'none' }}
              >
                Перейти к входу
              </Link>
            ) : (
              <>
                Не получили письмо?{' '}
                <Link
                  to="/forgot-password"
                  style={{ color: 'var(--bs-primary)', fontWeight: 500, textDecoration: 'none' }}
                >
                  Запросить снова
                </Link>
              </>
            )}
          </p>
        </div>
      </Container>
    </div>
  );
}
